const state = {
  /** 公告列表 */
  noticeList: [],
  /** 公告id对应map */
  noticeMap: {}
}

const mutations = {
  /** 设置公告列表 */
  setNoticeList(state, newArr) {
    state.noticeList = [...newArr];
    const tempMap = {}
    newArr.forEach(element => {
      tempMap[element.id] = element
    });
    state.noticeMap = tempMap
  },
  /** 设置公告为已读 */
  setNoticeReadedInModel(state, id) {
    const { noticeList, noticeMap } = state
    for (let index = 0; index < noticeList.length; index++) {
      const item = noticeList[index];
      if (item.id === id) {
        item.isRead = 1
        break
      }
    }
    noticeMap[id].isRead = 1
  }
}

export default ({
  namespaced: true,
  state,
  // getters,
  // actions,
  mutations
})